import classNames from 'classnames';

import { DividerFragmentFragment } from '../../__generated__/graphql';
import Divider from '../../components/Divider';
import { ContentBlock } from '../types';

import styles from './divider-content-block.module.css';

/**
 * This component is intended to allow the CMS to determine the placement of a divider in the content.
 * This should not be used in the codebase for any other purpose.
 * For devs that need to add a divider, use the Divider component.
 */
const DividerContentBlock: ContentBlock<DividerFragmentFragment> = ({ fragment }) => {
  const contentBlockProps = fragment.divider;

  if (!contentBlockProps) {
    return null;
  }

  return (
    <div
      className={classNames(
        styles.dividerContentBlockContainer,
        contentBlockProps.darkBackground ? styles.dividerBackgroundBlack : styles.dividerBackgroundWhite,
      )}
      id={contentBlockProps.sectionId ?? undefined}
    >
      <div className={styles.dividerContent}>
        <Divider
          thickness={2}
          variant="gradient"
        />
      </div>
    </div>
  );
};

export default DividerContentBlock;
